import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P0003607, P0003607Data } from './P0003607';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';

export class P00049 extends IProduct {
  override deviceTableIndex: number = 12;

  override modelIdentifier?: string = 'P00049';

  override dataIdentifier?: string = 'P00049';

  override manufacturerName?: string = 'ACWA';

  data: P0003607Data = new P0003607Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00049/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00049/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00049/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00049;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00049?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00049.tuto.installation.help.title',
      helpSlides: [
        'P00049.tuto.installation.help.1',
        'P00049.tuto.installation.help.2',
        'P00049.tuto.installation.help.3',
        'P00049.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00049/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00049/installation-1_dark.png',
          },
          text: 'P00049.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00049/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00049/installation-2_dark.png',
          },
          text: 'P00049.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00049/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00049/installation-1_dark.png',
          },
          text: 'P00049.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00049/update-2.png',
            dark: '/assets/ecosystem/images/products/P00049/update-2_dark.png',
          },
          text: 'P00049.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return new P0003607().getCPSConfig();
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return new P0003607().getEventProductFunctionalities();
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    return new P0003607().getCPSConfigByFonctionnality(functionnality);
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return new P0003607().getPropertyForOTAUpdate();
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 18;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).esIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
